export enum CheckoutSuccessAction {
  SelfRedirect = 'SELF_REDIRECT',
  ExternalRedirect = 'EXT_REDIRECT',
  ExternalPostRedirect = 'EXT_REDIRECT_POST',
  ExternalPaymentWidget = 'EXT_PAYMENT_WIDGET',
  AdyenFingerprint = 'ADYEN_IDENTIFYSHOPPER',
  AdyenChallenge = 'ADYEN_CHALLENGESHOPPER',
  CybersourceDeviceDataCollection = 'CYBERSOURCE_DEVICEDATACOLLECTION',
  CybersourceStepUpIframe = 'CYBERSOURCE_STEPUP',
  FormSubmit = 'FORM_SUBMIT',
}

export const CHECKOUT_REDIRECT_ACTIONS: ReadonlyArray<CheckoutSuccessAction> = [
  CheckoutSuccessAction.SelfRedirect,
  CheckoutSuccessAction.ExternalRedirect,
]

export const CHECKOUT_SUCCESS_ADYEN_ACTIONS: ReadonlyArray<CheckoutSuccessAction> = [
  CheckoutSuccessAction.AdyenFingerprint,
  CheckoutSuccessAction.AdyenChallenge,
]

export const CHECKOUT_SUCCESS_CYBERSOURCE_ACTIONS: ReadonlyArray<CheckoutSuccessAction> = [
  CheckoutSuccessAction.CybersourceDeviceDataCollection,
  CheckoutSuccessAction.CybersourceStepUpIframe,
]
